import { registerLocaleData } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import localeDa from "@angular/common/locales/da";
import { APP_INITIALIZER, ErrorHandler, Injector, LOCALE_ID, NgModule } from "@angular/core";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { CookieService } from "ngx-cookie-service";

import { DffRedirectService } from "@dffedb/router";
import { ENV, LogentriesLoggerService, LOGGER } from "@dffedb/util";
import { AppShellModule } from "@e-forsyning/common/app-shell";
import { EforsyningErrorHandler } from "@e-forsyning/common/error";
import { EforsyningHttpInterceptor } from "@e-forsyning/common/http";
import { initUmbracoIndstillinger } from "@e-forsyning/common/umbraco-indstillinger";
import {
    DffedbCookieConsentModule,
    DffedbCookieConsentOverlayModule,
    DffedbDriftsstatusKnapModule,
    DffedbEBoksTilmeldModule,
    DffedbFancyboxModule,
    DffedbForsyningPaaAdresseModule,
    DffedbIframeModule,
    DffedbInfoPopupModule,
    DffedbPrisberegnerModule,
    DffedbTilslutningsanmodningModule,
    EForsyningLogindKnapModule,
    DffedbMapModule // Registrerer WebComponent <dffedb-forsyning-paa-adresse>
} from "@e-forsyning/web-components";

import { environment } from "../environments/environment";
import { AppComponent } from "./app.component";

registerLocaleData(localeDa);



export function appInit(injector: Injector): () => void {
    return () => {
        initUmbracoIndstillinger(injector, (window as any).initUmbracoIndstillinger);
    };
}
